<template>
  <div class="kiosk-categories-sidebar">
    <div
      class="categories-logo"
      @click="$emit('logo-click')"
    >
      <div
        class="categories-logo-circle"
        :class="{ 'has-image': hasLogo }"
        :style="!hasLogo ? { background: primaryColor || '#ef4444' } : {}"
      >
        <img
          v-if="hasLogo"
          :src="logo"
          :alt="storeName"
          class="categories-logo-image"
        >
        <span
          v-else
          class="categories-logo-initial"
        >{{ initial }}</span>
      </div>
      <span class="categories-logo-text">Menu</span>
    </div>
    <div class="categories-divider" />
    <div class="categories-list">
      <button
        @click="$emit('select-category', 'all')"
        class="category-btn"
        :class="{ active: currentCategory === 'all' }"
      >
        <div class="category-btn-icon">
          <div class="category-placeholder">
            <KioskIcon
              name="all-items"
              size="24"
              stroke-width="1.5"
            />
          </div>
        </div>
        <span class="category-btn-text">All Items</span>
      </button>

      <button
        v-for="category in categories"
        :key="category.id"
        @click="$emit('select-category', category.id)"
        class="category-btn"
        :class="{ active: category.id === currentCategory }"
      >
        <div class="category-btn-icon">
          <img
            v-if="category.image"
            :src="category.image"
            :alt="category.name"
            class="category-image"
          >
          <div
            v-else
            class="category-placeholder"
          >
            <KioskIcon
              name="placeholder"
              size="24"
              stroke-width="1.5"
            />
          </div>
        </div>
        <span class="category-btn-text">{{ category.name }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import KioskIcon from "./KioskIcon.vue";

export default {
  name: "CategoriesSidebarV2",
  components: {
    KioskIcon,
  },
  props: {
    categories: Array,
    currentCategory: [String, Number],
    primaryColor: String,
    logo: String,
    hasLogo: Boolean,
    storeName: String,
    initial: String,
  },
};
</script>

<style scoped>
.kiosk-categories-sidebar {
  width: 96px;
  background: white;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 8px;
  overflow-y: auto;
  z-index: 10;
}

.categories-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
  padding-top: 8px;
  cursor: pointer;
  transition: transform 0.2s;
}

.categories-logo:hover {
  transform: scale(0.95);
}

.categories-logo-circle {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 4px;
  overflow: hidden;
}

.categories-logo-circle.has-image {
  background: transparent !important;
  box-shadow: none;
  border-radius: 0;
  overflow: visible;
}

.categories-logo-image {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  object-fit: contain;
}

.categories-logo-initial {
  font-size: 24px;
  font-weight: 700;
  color: white;
  text-transform: uppercase;
  font-family: "Merriweather", serif;
}

.categories-logo-text {
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  text-align: center;
  line-height: 1;
  color: #111827;
}

.categories-divider {
  width: 48px;
  height: 1px;
  background: #e5e7eb;
  margin-bottom: 16px;
}

.categories-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  flex: 1;
}

.category-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 8px;
  border-radius: 12px;
  transition: all 0.2s;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #9ca3af;
}

.category-btn:hover {
  background: #f3f4f6;
  color: #4b5563;
}

.category-btn.active {
  background: #2563eb;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transform: scale(1.05);
}

.category-btn-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid transparent;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  transition: all 0.2s;
}

.category-btn.active .category-btn-icon {
  border-color: white;
  background: white;
}

.category-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.category-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  color: #9ca3af;
}

.category-placeholder::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 10px,
    rgba(255, 255, 255, 0.1) 10px,
    rgba(255, 255, 255, 0.1) 20px
  );
  animation: shimmer 3s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%);
  }
  100% {
    transform: translateX(100%) translateY(100%);
  }
}

.category-btn-text {
  font-size: 9px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  text-align: center;
  line-height: 1.2;
}
</style>
